/**
 * @fileoverview gRPC-Web generated client stub for witbooking.backoffice.blacklist.v1
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!



const grpc = {};
grpc.web = require('grpc-web');

const proto = {};
proto.witbooking = {};
proto.witbooking.backoffice = {};
proto.witbooking.backoffice.blacklist = {};
proto.witbooking.backoffice.blacklist.v1 = require('./blacklist_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.backoffice.blacklist.v1.BlacklistAPIClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.backoffice.blacklist.v1.BlacklistAPIPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.blacklist.v1.GetBlacklistedUsersRequest,
 *   !proto.witbooking.backoffice.blacklist.v1.GetBlacklistedUsersResponse>}
 */
const methodDescriptor_BlacklistAPI_GetBlacklistedUsers = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.blacklist.v1.BlacklistAPI/GetBlacklistedUsers',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.blacklist.v1.GetBlacklistedUsersRequest,
  proto.witbooking.backoffice.blacklist.v1.GetBlacklistedUsersResponse,
  /**
   * @param {!proto.witbooking.backoffice.blacklist.v1.GetBlacklistedUsersRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.blacklist.v1.GetBlacklistedUsersResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.blacklist.v1.GetBlacklistedUsersRequest,
 *   !proto.witbooking.backoffice.blacklist.v1.GetBlacklistedUsersResponse>}
 */
const methodInfo_BlacklistAPI_GetBlacklistedUsers = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.blacklist.v1.GetBlacklistedUsersResponse,
  /**
   * @param {!proto.witbooking.backoffice.blacklist.v1.GetBlacklistedUsersRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.blacklist.v1.GetBlacklistedUsersResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.blacklist.v1.GetBlacklistedUsersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.blacklist.v1.GetBlacklistedUsersResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.blacklist.v1.GetBlacklistedUsersResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.blacklist.v1.BlacklistAPIClient.prototype.getBlacklistedUsers =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.blacklist.v1.BlacklistAPI/GetBlacklistedUsers',
      request,
      metadata || {},
      methodDescriptor_BlacklistAPI_GetBlacklistedUsers,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.blacklist.v1.GetBlacklistedUsersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.blacklist.v1.GetBlacklistedUsersResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.blacklist.v1.BlacklistAPIPromiseClient.prototype.getBlacklistedUsers =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.blacklist.v1.BlacklistAPI/GetBlacklistedUsers',
      request,
      metadata || {},
      methodDescriptor_BlacklistAPI_GetBlacklistedUsers);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.blacklist.v1.UpsertEngineBlacklistRequest,
 *   !proto.witbooking.backoffice.blacklist.v1.UpsertEngineBlacklistResponse>}
 */
const methodDescriptor_BlacklistAPI_UpsertEngineBlacklist = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.blacklist.v1.BlacklistAPI/UpsertEngineBlacklist',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.blacklist.v1.UpsertEngineBlacklistRequest,
  proto.witbooking.backoffice.blacklist.v1.UpsertEngineBlacklistResponse,
  /**
   * @param {!proto.witbooking.backoffice.blacklist.v1.UpsertEngineBlacklistRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.blacklist.v1.UpsertEngineBlacklistResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.blacklist.v1.UpsertEngineBlacklistRequest,
 *   !proto.witbooking.backoffice.blacklist.v1.UpsertEngineBlacklistResponse>}
 */
const methodInfo_BlacklistAPI_UpsertEngineBlacklist = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.blacklist.v1.UpsertEngineBlacklistResponse,
  /**
   * @param {!proto.witbooking.backoffice.blacklist.v1.UpsertEngineBlacklistRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.blacklist.v1.UpsertEngineBlacklistResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.blacklist.v1.UpsertEngineBlacklistRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.blacklist.v1.UpsertEngineBlacklistResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.blacklist.v1.UpsertEngineBlacklistResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.blacklist.v1.BlacklistAPIClient.prototype.upsertEngineBlacklist =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.blacklist.v1.BlacklistAPI/UpsertEngineBlacklist',
      request,
      metadata || {},
      methodDescriptor_BlacklistAPI_UpsertEngineBlacklist,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.blacklist.v1.UpsertEngineBlacklistRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.blacklist.v1.UpsertEngineBlacklistResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.blacklist.v1.BlacklistAPIPromiseClient.prototype.upsertEngineBlacklist =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.blacklist.v1.BlacklistAPI/UpsertEngineBlacklist',
      request,
      metadata || {},
      methodDescriptor_BlacklistAPI_UpsertEngineBlacklist);
};


module.exports = proto.witbooking.backoffice.blacklist.v1;

